import { useAppContext } from "hooks/useContext";
import type { ActiveVariantIdsType } from "lib/apollo/types";

export const useVariantIds = (): ActiveVariantIdsType => {
  const { variantIds } = useAppContext();
  return variantIds;
};
